// import qs from 'qs';
import defaultApi from '@/utils/request';

export default {
  // 加載列表
  Load(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_TeachPlace/Load',
      params,
    });
  },
  SelectData(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_TeachPlace/SelectData',
      params,
    });
  },
  // 抓取單筆
  Get(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_TeachPlace/Get',
      params,
    });
  },
  SelectRemainData(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_TeachPlace/SelectRemainData',
      params,
    });
  },
  // 新增
  Add(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_TeachPlace/Add',
      data,
    });
  },
  // 更新
  Update(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_TeachPlace/Update',
      data,
    });
  },
  // 刪除
  Delete(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_TeachPlace/Delete',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data,
    });
  },
};
